import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useLanguage } from '../context/LanguageContext';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faUser, faEdit, faKey, faSignOutAlt, faHome
} from "@fortawesome/free-solid-svg-icons";
import DenyAccessPage from '../components/DenyAccessPage';
import { changePasswordUser } from 'services/auth';
import toast from 'react-hot-toast';
import UserProfileData from 'components/ui/UserProfileData';

const WisdomUserProfile = () => {
    const navigate = useNavigate();
    const { logout, userInfo } = useAuth();
    const { language } = useLanguage();

    const [showPasswordModal, setShowPasswordModal] = useState(false);
    const [newPassword, setNewPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [showPassword, setShowPassword] = useState(false);

    const handlePasswordSubmit = async () => {
        try {
            if (!newPassword || !confirmPassword) return;

            if (newPassword !== confirmPassword) {
                toast.error(language ? "Passwords do not match" : "كلمات المرور غير متطابقة");
                return;
            }

            await changePasswordUser(userInfo?.id, newPassword)
            toast.success(language ? "password has been updated sucessfully" : "تم تغيير الرقم السري بنجاح");
            // TODO: call API here

            setNewPassword("");
            setConfirmPassword("");
            setShowPasswordModal(false);
        } catch (err) {
            toast.error(language ? "error please try again later" : 'حصل خطا الرجاء المحاول مرة اخري')
        }
    };

    // const handleInputChange = (field, value) => {
    //     setProfileData(prev => ({
    //         ...prev,
    //         [field]: value
    //     }));
    // };

    // const handleSave = () => {
    //     // هنا يمكن إضافة منطق حفظ البيانات
    //     setIsEditing(false);
    // };

    // const handleCancel = () => {
    //     setIsEditing(false);
    //     // إعادة تعيين البيانات للقيم الأصلية
    //     setProfileData({
    //         name: initialName,
    //         email: userInfo?.email,
    //         phone: '+966 50 123 4567',
    //         department: 'إدارة تقنية المعلومات',
    //         position: userInfo?.employee_role,
    //         employeeId: 'EMP-2024-001',
    //         joinDate: '2024-01-15',
    //         location: 'الرياض، المملكة العربية السعودية',
    //         avatar: null
    //     });
    // };

    if (userInfo?.code === 1452 || userInfo?.code === 1476) return <DenyAccessPage homePage='/watoms/dashboard' />;
    if (userInfo?.code === 1475) return <DenyAccessPage homePage='/watoms/news' />;
    if (userInfo?.code === 1310) return <DenyAccessPage homePage='/wisdom/dashboard' />;
    // if (!userInfo?.user_permissions.some(per => per.page.name === "Wisdom User Profile Page")) return <DenyAccessPage homePage='/' />;

    return (
        <div className="min-h-screen bg-gradient-to-br from-blue-50 via-white to-purple-100 dark:bg-darkBg font-[Cairo,sans-serif]" dir={language ? "ltr" : "rtl"}>
            {/* Header */}
            <div className="bg-white dark:bg-darkCard shadow-lg">
                <div className="max-w-7xl mx-auto px-6 py-4">
                    <div className="flex items-center justify-between">
                        <div className="flex items-center gap-4">
                            <button
                                onClick={() => navigate('/user-home')}
                                className="text-watomsBlue hover:text-watomsLightBlue transition-colors"
                            >
                                <FontAwesomeIcon icon={faUser} className="text-2xl" />
                            </button>
                            <h1 className="text-2xl font-bold text-watomsBlue dark:text-watomsLightBlue">
                                {language ? 'My Profile' : 'الملف الشخصي'}
                            </h1>
                        </div>
                        <div className="flex items-center gap-3">
                            <button
                                onClick={() => navigate('/wisdom')}
                                className="bg-watomsBlue hover:bg-watomsLightBlue text-white px-4 py-2 rounded-lg flex items-center gap-2 transition-colors"
                                title="الصفحة الرئيسية"
                            >
                                <FontAwesomeIcon icon={faHome} />
                                {language ? 'Home' : 'الرئيسية'}
                            </button>
                            {/* {!isEditing ? (
                                <button
                                    onClick={() => setIsEditing(true)}
                                    className="bg-watomsBlue hover:bg-watomsLightBlue text-white px-4 py-2 rounded-lg flex items-center gap-2 transition-colors"
                                >
                                    <FontAwesomeIcon icon={faEdit} />
                                    {language ? 'Edit' : 'تعديل'}
                                </button>
                            ) : (
                                <div className="flex items-center gap-2">
                                    <button
                                        onClick={handleSave}
                                        className="bg-green-600 hover:bg-green-700 text-white px-4 py-2 rounded-lg flex items-center gap-2 transition-colors"
                                    >
                                        <FontAwesomeIcon icon={faSave} />
                                        {language ? 'Save' : 'حفظ'}
                                    </button>
                                    <button
                                        onClick={handleCancel}
                                        className="bg-gray-500 hover:bg-gray-600 text-white px-4 py-2 rounded-lg flex items-center gap-2 transition-colors"
                                    >
                                        <FontAwesomeIcon icon={faTimes} />
                                        {language ? 'Cancel' : 'إلغاء'}
                                    </button>
                                </div>
                            )} */}
                        </div>
                    </div>
                </div>
            </div>

            {/* Main Content */}
            <div className="max-w-4xl mx-auto px-6 py-8">
                <div className="">
                    <UserProfileData userId={userInfo?.id} role={userInfo.user_role}/>
                    {/* Security & Settings */}
                    <div className="mt-6 bg-white dark:bg-darkCard rounded-2xl shadow-xl p-6">
                        <h3 className="text-xl font-bold text-gray-800 dark:text-darkText mb-6">
                            {language ? 'Security & Settings' : 'الأمان والإعدادات'}
                        </h3>

                        <div className="space-y-4">
                            <button
                                onClick={() => setShowPasswordModal(true)}
                                className="w-full flex items-center justify-between p-4 bg-gray-300 dark:bg-darkBorder rounded-lg hover:bg-gray-200 dark:hover:bg-darkBorder/80 transition-colors"
                            >
                                <div className="flex items-center gap-3">
                                    <FontAwesomeIcon icon={faKey} className="text-watomsBlue" />
                                    <span className="text-gray-800 dark:text-darkText">
                                        {language ? 'Change Password' : 'تغيير كلمة المرور'}
                                    </span>
                                </div>
                                <FontAwesomeIcon icon={faEdit} className="text-gray-600" />
                            </button>
                            {/*
                                <button className="w-full flex items-center justify-between p-4 bg-gray-50 dark:bg-darkBorder rounded-lg hover:bg-gray-100 dark:hover:bg-darkBorder/80 transition-colors">
                                    <div className="flex items-center gap-3">
                                        <FontAwesomeIcon icon={faBell} className="text-watomsBlue" />
                                        <span className="text-gray-800 dark:text-darkText">
                                            {language ? 'Notification Settings' : 'إعدادات الإشعارات'}
                                        </span>
                                    </div>
                                    <FontAwesomeIcon icon={faCog} className="text-gray-400" />
                                </button>

                                <button className="w-full flex items-center justify-between p-4 bg-gray-50 dark:bg-darkBorder rounded-lg hover:bg-gray-100 dark:hover:bg-darkBorder/80 transition-colors">
                                    <div className="flex items-center gap-3">
                                        <FontAwesomeIcon icon={faShieldAlt} className="text-watomsBlue" />
                                        <span className="text-gray-800 dark:text-darkText">
                                            {language ? 'Privacy Settings' : 'إعدادات الخصوصية'}
                                        </span>
                                    </div>
                                    <FontAwesomeIcon icon={faCog} className="text-gray-400" />
                                </button> */}

                            <button
                                onClick={logout}
                                className="w-full flex items-center justify-between p-4 bg-red-50 dark:bg-red-900/20 rounded-lg hover:bg-red-100 dark:hover:bg-red-900/30 transition-colors"
                            >
                                <div className="flex items-center gap-3">
                                    <FontAwesomeIcon icon={faSignOutAlt} className="text-red-600" />
                                    <span className="text-red-600 font-medium">
                                        {language ? 'Sign Out' : 'تسجيل الخروج'}
                                    </span>
                                </div>
                                <FontAwesomeIcon icon={faSignOutAlt} className="text-red-400" />
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            {showPasswordModal && (
                <div
                    className="fixed inset-0 bg-black/50 flex items-center justify-center z-50"
                    dir={language ? "ltr" : "rtl"}
                >
                    <div className="bg-white dark:bg-darkCard p-6 rounded-xl w-[90%] max-w-md shadow-2xl">

                        <h2 className="text-xl font-bold mb-4 text-gray-800 dark:text-darkText">
                            {language ? "Change Password" : "تغيير كلمة المرور"}
                        </h2>

                        {/* New Password */}
                        <div className="relative mb-3">
                            <input
                                type={showPassword ? "text" : "password"}
                                value={newPassword}
                                onChange={(e) => setNewPassword(e.target.value)}
                                placeholder={language ? "New password" : "كلمة المرور الجديدة"}
                                className="w-full px-4 py-2 border rounded-lg dark:bg-darkBorder dark:text-darkText"
                            />
                        </div>

                        {/* Confirm Password */}
                        <div className="relative mb-4">
                            <input
                                type={showPassword ? "text" : "password"}
                                value={confirmPassword}
                                onChange={(e) => setConfirmPassword(e.target.value)}
                                placeholder={language ? "Confirm password" : "تأكيد كلمة المرور"}
                                className="w-full px-4 py-2 border rounded-lg dark:bg-darkBorder dark:text-darkText"
                            />
                        </div>

                        {/* Show / Hide toggle */}
                        <button
                            onClick={() => setShowPassword(!showPassword)}
                            className="text-sm text-watomsBlue mb-4"
                        >
                            {showPassword
                                ? (language ? "Hide Password" : "إخفاء كلمة المرور")
                                : (language ? "Show Password" : "إظهار كلمة المرور")}
                        </button>

                        {/* Actions */}
                        <div className="flex gap-2">
                            <button
                                onClick={handlePasswordSubmit}
                                className="px-4 py-2 bg-watomsBlue text-white rounded-lg"
                            >
                                {language ? "Submit" : "تأكيد"}
                            </button>

                            <button
                                onClick={() => {
                                    setShowPasswordModal(false);
                                    setNewPassword("");
                                    setConfirmPassword("");
                                }}
                                className="px-4 py-2 bg-gray-300 rounded-lg"
                            >
                                {language ? "Cancel" : "إلغاء"}
                            </button>
                        </div>

                    </div>
                </div>
            )}
        </div>
    );
};

export default WisdomUserProfile;
